import cl from "clsx";
import arrowTop from "@/public/icons/arrow-corner.svg";
import arrowTopBlack from "@/public/icons/arrow-top-black.svg";
import arrowBottomWhite from "@/public/icons/arrow-bottom-white.svg";
import arrowQuizRight from "@/public/icons/arrow-button-quiz-right.svg";
import arrowQuizRightWhite from "@/public/icons/arrow-button-quiz-right-white.svg";
import howArrow from "@/public/icons/how-arrow.svg";
import Image from "next/image";
import { GoArrowLeft } from "react-icons/go";
import { GoArrowRight } from "react-icons/go";
import circle from '@/public/icons/circle.svg';
import styles from "./styles.module.css";
import { Spinner } from '@chakra-ui/react';
/**
 *
 * @param {string} title - text
 * @param {string} type - sign-up | login-in | round-top-right | round-bottom-mobile |round-bottom | round-left |round-right | how-arrow | arrow-top-black | login-modal
 * @param {string} externalText - text at the button
 * @param {string} section  - position button of the project
 * @param {string} typeButton - type of button
 * @param {function} onClick
 *
 * @param value
 * @param disabled
 * @param dataName
 */

export default function Button({
       typeButton,
       onClick,
       title,
       type,
       externalText,
       section,
       value,
       disabled = false,
       onSpinner = false
   }) {
    let arrow;

    switch (type) {
        case "round-top-right":
            arrow = <Image src={arrowTop} alt="arrow" />;
            break;
        case "round-bottom-mobile":
        case "round-bottom":
            arrow = <Image src={arrowBottomWhite} alt="arrow" />;
            break;
        case "round-left-grey":
        case "round-left-grey-sm":
        case "round-left":
            arrow = <GoArrowLeft className={styles.button__go_arrow_left} />;
            break;
        case "round-right-grey":
        case "round-right-grey-sm":
        case "round-right":
            arrow = <GoArrowRight className={styles.button__go_arrow_right} />;
            break;
        case "how-arrow":
            arrow = <Image src={howArrow} alt="arrow" />;
            break;
        case "arrow-top-black":
            arrow = <Image src={arrowTopBlack} alt="arrow" />;
            break;
        default:
            arrow = <Image src={arrowTop} alt="arrow" />;
    }

    return (
        <div onClick={onClick} className={styles.button__wrapper}>
            <button
                className={cl(
                    styles.button,
                    type === "sign-up" && styles.button__signup,
                    type === "login-in" && styles.button__login,
                    type === "round-top-right" && styles.button__round,
                    type === "round-bottom-mobile" && styles.button__round_mobile,
                    type === "round-bottom" && styles.button__round,
                    type === "round-left" && styles.button__round_left,
                    type === "round-right" && styles.button__round_right,
                    type === "round-left-grey" && styles.button__round_left_grey,
                    type === "round-right-grey" && styles.button__round_right_grey,
                    type === "round-left-grey-sm" && styles.button__round_left_grey_sm,
                    type === "round-right-grey-sm" && styles.button__round_right_grey_sm,
                    type === "how-arrow" && styles.button__how,
                    type === "submit" && styles.button__submit,
                    type === "arrow-top-black" && styles.button__arrow_top_black,
                    section === "discover" && styles.button__hover_black,
                    type === "login-modal" && styles.button__login_modal,
                    type === "signup-modal" && styles.button__signup_modal,
                    type === "quiz" && styles.button__quiz,
                    type === "yellow-oval" && styles.button__yellow_oval,
                    type === "go-back" && styles.button__go_back,
                    type === "yes" && styles.button__yes,
                    value && styles.button__yes_active,
                    type === 'restart' && styles.button__restart,
                    type === "account" && styles.button__account,
                    disabled && styles.button__disabled,
                    type === "discover-login" && styles.discover_login
                )}
                type={typeButton}
                disabled={disabled || onSpinner} // Disable the button if spinner is active
            >
                {onSpinner ? (
                    <Spinner
                        thickness='3px'
                        speed='0.65s'
                        color='gray.600'
                        size='lg'
                    />
                ) : (
                    <>
                        {type === "go-back" && (
                            <Image
                                className={styles.button__arrow_title_go_back}
                                src={arrowQuizRight}
                                alt="arrow-right"
                            />
                        )}
                        {title ? title : arrow}
                        {type === "quiz" && (
                            <Image
                                className={cl(
                                    styles.button__arrow_title,
                                    disabled && styles.button__arrow_title_disabled
                                )}
                                src={disabled ? arrowQuizRightWhite : arrowQuizRight}
                                alt="arrow-right"
                            />
                        )}
                        {type === "restart" && (
                            <Image className={styles.button__circle} src={circle} alt="circle" />
                        )}
                    </>
                )}
            </button>
            <div
                className={cl(
                    section === "hero-video"
                        ? styles.button__external_video
                        : styles.button__external,
                    type === "how-arrow" && styles.button__external_how
                )}
            >
                <p
                    className={cl(
                        section === "hero" && styles.button__hero_text,
                        section === "hero-video" && styles.button__hero_video_text
                    )}
                >
                    {externalText}
                </p>
            </div>
        </div>
    );
}
